import './toggle.scss';
var TOGGLE_ON_SELECTOR = '[data-js-toggle-on]';
var TOGGLE_OFF_SELECTOR = '[data-js-toggle-off]';
var TOGGLE_SELECTOR = '[data-js-toggle]';

function setupPageToggles(element) {
  element.querySelectorAll(TOGGLE_ON_SELECTOR).forEach(setupToggledElement);
  element.querySelectorAll(TOGGLE_OFF_SELECTOR).forEach(setupToggledElement);
  element.querySelectorAll(TOGGLE_SELECTOR).forEach(setupToggleElement);
}

function setupToggleElement(element) {
  if (element.hasSetupToggle) {
    return;
  }

  element.hasSetupToggle = true;
  element.toggleId = element.getAttribute('data-js-toggle-id') || element.id;
  element.addEventListener('change', function (_event) {
    updateElementToggles(element);
  });

  if (element.type !== 'radio' || element.checked) {
    updateElementToggles(element);
  }
}

function setupToggledElement(element) {
  if (element.hasSetupToggle) {
    return;
  }

  element.hasSetupToggle = true;
  var onValue = element.getAttribute('data-js-toggle-on') || null;

  if (onValue) {
    onValue = onValue.replace(/^.*?=/, '');

    if (onValue.match(/^\[.*\]$/)) {
      onValue = JSON.parse(onValue);

      element.matchesToggleOn = function (value) {
        return this.toggleOnValue.includes(value);
      };
    } else {
      element.matchesToggleOn = function (value) {
        return this.toggleOnValue === value;
      };
    }
  }

  element.toggleOnValue = onValue;
  var offValue = element.getAttribute('data-js-toggle-off') || null;

  if (offValue) {
    offValue = offValue.replace(/^.*?=/, '');

    if (offValue.match(/^\[.*\]$/)) {
      offValue = JSON.parse(offValue);

      element.matchesToggleOff = function (value) {
        return this.toggleOffValue.includes(value);
      };
    } else {
      element.matchesToggleOff = function (value) {
        return this.toggleOffValue === value;
      };
    }
  }

  element.toggleOffValue = offValue;
}

function updateElementToggles(element) {
  var value = getElementValue(element);
  document.querySelectorAll("[data-js-toggle-on^=\"".concat(element.toggleId, "=\"]")).forEach(function (toggle) {
    if (toggle.matchesToggleOn(value)) {
      toggle.classList.add('js-toggle--on');
    } else {
      toggle.classList.remove('js-toggle--on');
    }
  });
  document.querySelectorAll("[data-js-toggle-off^=\"".concat(element.toggleId, "=\"]")).forEach(function (toggle) {
    if (toggle.matchesToggleOff(value)) {
      toggle.classList.add('js-toggle--off');
    } else {
      toggle.classList.remove('js-toggle--off');
    }
  });
}

function getElementValue(element) {
  switch (element.tagName) {
    case 'INPUT':
      if (element.type === 'checkbox') {
        return element.checked ? 'true' : 'false';
      }

      break;
  }

  return element.value;
}

document.addEventListener('turboujs:load', function (_event) {
  return setupPageToggles(document);
});
document.addEventListener('popover:display', function (event) {
  return setupPageToggles(event.detail);
});